import Link from "next/link";

interface FormFooterProps {
    footerText: string,
    actionText: string,
    actionHref: string
}

export default function FormFooter(props: FormFooterProps) {
    return (
        <p className="text-center text-black p-4 mt-2">
           {props.footerText + ' '}
            <Link href={props.actionHref} className="text-[#93885B] hover:underline hover:text-[#0a58ca]">
                {props.actionText}
            </Link>
        </p>
    );
}